export enum PersonalIdEnum {
  PERSONAL_ID ='personalId',
  PASSPORT = 'passport',
  CITIZENSHIP_CARD = 'citizenshipCard',
  DRIVER_LICENSE = 'driverLicense',
  OTHER = 'otherDocument',
}
